import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CartaServicoService from '../../../../../services/cartaServico-auth';
import SecretariaService from '../../../../../services/secretaria';



const CartaServico = () => {
    const [servico, setServico] = useState("");
    const [finalidade, setFinalidade] = useState("");
    const [requisitos, setRequisitos] = useState("");
    const [etapas, setEtapas] = useState("");
    const [tempo, setTempo] = useState("");
    const [local, setLocal] = useState("");
    const [secretaria, setSecretaria] = useState("");
    const [secretarias, setSecretarias] = useState([])
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    const montaSec = async () => {
        const secs = await SecretariaService.listar()
        setSecretarias(secs.data)
    }

    useEffect(() => {
        montaSec()
    }, [])

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const carta = await CartaServicoService.cadastro({
                servico: servico,
                finalidade: finalidade,
                requisitos: requisitos,
                etapas: etapas,
                tempo: tempo,
                local: local,
                secretaria: secretaria
            })
            if (carta.data["_id"]) {
                alert("Carta de Serviço cadastrada com sucesso!")
                setSucesso(true);
            }
            else {
                alert(carta.data["error"]);
            }
        } catch (error) {
            console.log(error)
        }
    }


    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setServico("");
        setFinalidade("");
        setRequisitos("");
        setEtapas("");
        setTempo("");
        setLocal("");
        setSecretaria("");
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                    <Col xs={12}>
                            <Form.Group className="mb-3" controlId="Processo">
                                <FloatingLabel
                                    label="Secretaria"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Secretaria"
                                        name="secretaria"
                                        onChange={e => setSecretaria(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        {secretarias.map((sec) =>
                                            <option value={sec.nome}>{sec.nome}</option>
                                        )}
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="servico">
                                <FloatingLabel
                                    label="Serviço"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="servico"
                                        value={servico}
                                        onChange={e => setServico(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="finalidade">
                                <FloatingLabel
                                    label="Finalidade"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="finalidade"
                                        value={finalidade}
                                        onChange={e => setFinalidade(e.target.value)} 
                                        as="textarea"
                                        rows={5} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="requisitos">
                                <FloatingLabel
                                    label="Requisitos"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="requisitos"
                                        value={requisitos}
                                        onChange={e => setRequisitos(e.target.value)} 
                                        as="textarea"
                                        rows={5} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="etapas">
                                <FloatingLabel
                                    label="Etapas"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="etapas"
                                        value={etapas}
                                        onChange={e => setEtapas(e.target.value)} 
                                        as="textarea"
                                        rows={5} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="tempo">
                                <FloatingLabel
                                    label="Tempo/Horários"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="tempo"
                                        value={tempo}
                                        onChange={e => setTempo(e.target.value)} 
                                        as="textarea"
                                        rows={3} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="local">
                                <FloatingLabel
                                    label="Local"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="local"
                                        value={local}
                                        onChange={e => setLocal(e.target.value)} 
                                        as="textarea"
                                        rows={3} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/institucional/cartaservico'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Carta de Serviço cadastrada com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outra
                </Button>
                <br /><br />
                <Link to={'/restrito/institucional/cartaservico/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Cartas de Serviço
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/institucional/cartaservico'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default CartaServico;